import { render, staticRenderFns } from "./MaintainStockAdd.vue?vue&type=template&id=0864d4f9"
import script from "./MaintainStockAdd.vue?vue&type=script&lang=js"
export * from "./MaintainStockAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports